import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONFIG } from '../config';


@Injectable()
export class QueryService {

    constructor(private http: HttpClient) {
    }

    private options(builder?: QueryBuilder) {
        let data = {
            headers: new HttpHeaders({
                'Accept': 'application/json',
                'enctype': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + (localStorage.getItem('api_token') || '')
            }),
        };

        if (builder) {
            data['params'] = builder.request;
        }
        return data;
    }

    full(model: string) {
        return this.http.get(CONFIG.url + '/api/v1/full/' + model).toPromise();
    }

    primaryKey(model: string) {
        return this.http.get(CONFIG.url + '/api/v1/primaryKey/' + model).toPromise();
    }

    model(model: string) {
        let response = this.http.get(CONFIG.url + '/api/v1/model/' + model);
        return response;
    }

    models(model: string) {
        let response = this.http.get(CONFIG.url + '/api/v1/models/' + model);
        return response;
    }

    fields(model: string) {
        let response = this.http.get(CONFIG.url + '/api/v1/fields/' + model);
        return response;
    }

    types(model: string) {
        let response = this.http.get(CONFIG.url + '/api/v1/types/' + model);
        return response;
    }

    call(model: string, method: string) {
        let response = this.http.get(CONFIG.url + '/api/v1/call/' + model + '/' + method);
        return response;
    }

    get(builder: QueryBuilder, id?: number) {
        return this.http.get(CONFIG.url + builder.url + (id ? ('/' + id) : ''), this.options(builder)).toPromise();
    }

    post(model: string, data) {
        let formData: FormData = new FormData();

        let keys = Object.keys(data);
        for (let i in keys) {
            let key = keys[i];
            formData.append(key, data[key]);
        }

        return this.http.post(CONFIG.url + '/api/v1/' + model, formData, this.options()).toPromise();
    }

    put(model: string, id: number, data) {
        let formData: FormData = new FormData();

        let keys = Object.keys(data);
        for (let i in keys) {
            let key = keys[i];
            formData.append(key, data[key]);
        }

        formData.append('_method', 'PUT');

        let response = this.http.post(CONFIG.url + '/api/v1/' + model + '/' + id, formData, this.options());
        return response;
    }

    httpPost(url: string, data, options?) {
        let response = this.http.post(CONFIG.url + url, data, options);
        return response;
    }

    delete(model: string, id: number) {
        return this.http.delete(CONFIG.url + '/api/v1/' + model + '/' + id, this.options()).toPromise();
    }
}


export class QueryBuilder {

    private _model = '';
    private _primaryKey = '';

    private _where = [];
    private _select = [];
    private _with = [];
    private _withCount = [];
    private _order = [];
    private _page = 0;
    private _per_page = 0;
    private _count = false;
    private _scopes = [];


    constructor(model: string, primary_key?: string) {
        this._model = model;
        this._primaryKey = primary_key ? primary_key : model + '_id';
    }

    get url() {
        return '/api/v1/' + this._model;
    }


    where(field: string, comparison: string, value: string | number) {
        this._where.push('["' + field + '","' + comparison + '","' + value + '"]');
        return this;
    }

    with(relation: string | string[]) {
        if (typeof relation == 'string') {
            this._with.push('"' + relation + '"');
        } else if (relation instanceof Array) {
            for (let i in relation) {
                this._with.push('"' + relation[i] + '"');
            }
        }
        return this;
    }

    withCount(relation: string) {
        this._withCount.push('"' + relation + '"');
        return this;
    }

    select(field: string) {
        this._select.push('"' + field + '"');
        return this;
    }

    orderBy(field: string, order: string) {
        this._order.push([ '"' + field + '"', '"' + order + '"' ]);
        return this;
    }

    page(page) {
        this._page = page;
        return this;
    }

    per_page(per_page) {
        this._per_page = per_page;
        return this;
    }

    count() {
        this._count = true;
        return this;
    }

    scope(scope: string) {
        this._scopes.push('"' + scope + '"');
        return this;
    }

    get request() {
        var request = {};
        if (this._where.length > 0) {
            request['where[]'] = this._where;
        }
        if (this._select.length > 0) {
            request['select[]'] = this._select;
        }
        if (this._with.length > 0) {
            request['with'] = '[' + this._with + ']';
        }
        if (this._withCount.length > 0) {
            request['withCount'] = '[' + this._withCount + ']';
        }
        if (this._order.length > 0) {
            request['order[]'] = '[' + this._order + ']';
        }
        if (this._page > 0) {
            request['page'] = this._page;
        }
        if (this._per_page > 0) {
            request['per_page'] = this._per_page;
        }
        if (this._count) {
            request['count'] = true;
        }
        if (this._scopes.length > 0) {
            request['scope'] = '[' + this._scopes + ']';
        }
        return request;
    }

    get model() {
        return this._model;
    }

    get primaryKey() {
        return this._primaryKey;
    }
}
